import { useEffect, useRef } from "react";
import styles from './ChamProjects.module.css'

// Base component 
export default function ChamProjects({ children }) {
    const chamProjectsRef = useRef(null);

    useEffect(() => {
        const chamProjects = chamProjectsRef.current;
        if (!chamProjects) return;

        const handleGotoViz = function (e) {
            // aux2 contains the saved project URL
            const projectUrl = e.value.aux2;
            
            if (projectUrl) {
                chamProjects.setAttribute("active", "0");
                // Navigate to the saved URL
                try {
                    const url = new URL(projectUrl);
                    window.location.href = url.pathname;
                } catch {
                    // If it's already a path (not full URL), navigate directly
                    window.location.href = projectUrl;
                }
            }
        };

        chamProjects.addEventListener('gotoviz', handleGotoViz);

        return () => {
            chamProjects.removeEventListener('gotoviz', handleGotoViz);
        };
    }, []);

    return (
        <cham-projects signup={true} ref={chamProjectsRef} base64thumb="1" className={styles.chamProjects}>
            {children}
        </cham-projects>
    );
}

// Open projects dialog 
export function ChamProjectsOpenButton({ className, title }) {

    const handleClick = function () {
        document.querySelector('cham-projects').setAttribute("active", "1");
    }

    return (
        <button onClick={handleClick} className={className}>{title}</button>
    )
}

// Saves a project
export function ChamProjectsSaveButton({ className, title }) {

    const handleClick = function () {
        let saveData = document.getElementById("chamViz").getSaveData();
        document.querySelector('cham-projects').saveProject(saveData.spec, saveData.sel);
    }

    return (
        <button onClick={handleClick} className={className}>{title}</button>
    )
}